module.exports = __webpack_public_path__ + "static/media/calendar-scheduled_oldDate.d827664f.svg";